module.exports = __webpack_public_path__ + "static/media/flag-ZH.de183510.svg";